// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-enter[data-v-1a223a67], .slide-leave-to[data-v-1a223a67]{\n  --tw-translate-x:100%\n}\n@media (min-width: 768px){\n.slide-enter[data-v-1a223a67], .slide-leave-to[data-v-1a223a67]{\n    --tw-translate-x:-100%\n}\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
